import IProfile from "../models/IProfile";
import { request } from "./ApiService";

export const saveProfile = (item: IProfile) => request("profile", { method: "PUT", body: item });
